// extracted by mini-css-extract-plugin
export default {"detailForm":"DetailMedia_detailForm__m1TWk","gallery":"DetailMedia_gallery__qJh8B"};